<!--<template>-->
    <!--<div id="app" >-->

        <!--&lt;!&ndash;<el-carousel height="90vh"  :interval="6000" arrow="always">&ndash;&gt;-->
            <!--&lt;!&ndash;<el-carousel-item     v-for="(img,index) in imgList" :key="index">&ndash;&gt;-->
                <!--&lt;!&ndash;<a target="_blank" v-bind:href="img.link">&ndash;&gt;-->
                    <!--&lt;!&ndash;<img class="cover"    v-bind:src="img.pic" >&ndash;&gt;-->
                <!--&lt;!&ndash;</a>&ndash;&gt;-->
            <!--&lt;!&ndash;</el-carousel-item>&ndash;&gt;-->
        <!--&lt;!&ndash;</el-carousel>&ndash;&gt;-->

        <!--<el-carousel height="90vh" :interval="6000" direction="horizontal" :autoplay="true">-->
            <!--<el-carousel-item v-for="(img,index) in imgList" :key="index">-->
                <!--<a target="_blank" v-bind:href="img.link">-->
                    <!--<img class="cover"    v-bind:src="img.picwap" >-->
                <!--</a>-->
            <!--</el-carousel-item>-->
        <!--</el-carousel>-->
    <!--</div>-->
<!--</template>-->
<!--<script>-->
  <!--import {getBanner} from "../../../api/index"-->
  <!--import 'element-ui/lib/theme-chalk/index.css'-->
  <!--import ElementUI from 'element-ui'-->
  <!--export default {-->
    <!--name: 'Lun',-->
    <!--data(){-->
      <!--return{-->

        <!--imgList:[-->
          <!--// {url:require('../../../assets/1.png'),link:"https://hao.360.com/?src=lm&ls=n2ec577739c"},-->
          <!--// {url:require('../../../assets/2.jpg'),link:"https://hao.360.com/?src=lm&ls=n2ec577739c"},-->
          <!--// {url:require('../../../assets/3.jpg'),link:"https://hao.360.com/?src=lm&ls=n2ec577739c"},-->
        <!--]-->
      <!--}-->
    <!--},-->
    <!--mounted(){-->
      <!--getBanner().then((res)=>{-->
      <!--console.log(res,"22222222");-->
      <!--return res;-->
    <!--})-->
        <!--.then((res)=>{-->
          <!--// 获取响应数据-->
          <!--let imgList = res.data;-->
          <!--this.imgList = imgList;-->

        <!--})-->
    <!--}-->
  <!--}-->
<!--</script>-->

<!--<style lang="less">-->
    <!--#app{-->
        <!--height: 90vh;-->
    <!--}-->

    <!--.el-carousel__item img {-->
        <!--width: 100%;-->
        <!--height:90vh;-->
        <!--margin: 0;-->
        <!--overflow:hidden;-->
    <!--}-->
    <!--/*.cover { object-fit: cover; }*/-->
    <!--/*.el-carousel__item:nth-child(2n) {*/-->
        <!--/*background-color: #99a9bf;*/-->
        <!--/*!*height: 500px;*!*/-->
    <!--/*}*/-->
    <!--/*.el-carousel__item:nth-child(2n+1) {*/-->

        <!--/*background-color: #d3dce6;*/-->
        <!--/*!*height: 500px;*!*/-->
    <!--/*}*/-->
    <!--/*.el-carousel__arrow{*/-->
        <!--/*!*top: 140%!important;*!*/-->
    <!--/*}*/-->

    <!--/*.el-carousel__item h3 {*/-->
        <!--/*color: #475669;*/-->
        <!--/*font-size: 14px;*/-->
        <!--/*opacity: 0.75;*/-->
        <!--/*line-height: 200px;*/-->
        <!--/*margin: 0;*/-->
    <!--/*}*/-->

    <!--.el-carousel__item:nth-child(2n) {-->
        <!--background-color: #99a9bf;-->
    <!--}-->

    <!--.el-carousel__item:nth-child(2n+1) {-->
        <!--background-color: #d3dce6;-->
    <!--}-->
<!--</style>-->

<template>
    <div class="page-wrap">
        <div class="header-area">
            <!--<Top />-->
        </div>
        <div class="slide-specified-index">
            <div class="banner-wrapper">
                <div class="slide-specified-wrapper" v-if="pageData" ref="slide">
                    <div class="slide-specified-content"
                         :style="{'visibility': isShow? 'visible': 'hidden'}">
                        <div v-for="(item, num) in pageData"
                             class="slide-page"
                             :style="{backgroundImage:`url(${item.picwap})`}" :key="num">
                            <div class="page-tit">

                            </div>
                            <div class="page-con">
                                <!--<a class="btn" href="#">了解更多→</a>-->
                                <div class="btn6" ></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="dots-wrapper">
        <span
                class="dot"
                v-for="(item, num) in pageData"
                :key="num"
                :class="{'active': currentPageIndex === num}"></span>
                </div>
            </div>
        </div>
    </div>
    <!--</div>-->
</template>

<script>
  // import Top from "../components/Top";
  import BScroll from '@better-scroll/core'
  import Slide from '@better-scroll/slide'
  import {getWapFirstPic} from '@/api/index';
  import {getBanner} from "../../../api/index"
  BScroll.use(Slide);
  export default {
    components:{
      // Top
    },
    data() {
      return {
        slideCreated: false,
        nums: 4,
        currentPageIndex: 0,
        pageData: null,
        isShow: false,
      }
    },
    created(){
      getBanner({}).then(res=>{
        this.pageData = res.data;
        setTimeout(()=>{
          this.isShow = true;
          this.init();
          this.slideCreated = true;
        }, 500);
      })
    },

    mounted() {
      // this.$nextTick(()=>{
      //   setTimeout(()=>{
      //     this.init();
      //     this.slideCreated = true
      //   }, 1000);
      // })
    },
    beforeDestroy() {
      // this.slide.destroy()
    },
    methods: {
      init() {
        this.slide = new BScroll(this.$refs.slide, {
          scrollX: true,
          scrollY: false,
          slide: true,
          momentum: false,
          bounce: false,
          probeType: 3,
          active: 1
        })
        // this.slide.on('scrollEnd', this._onScrollEnd)

        this.slide.on('slideWillChange', (page) => {
          this.currentPageIndex = page.pageX
        });
      },
      _onScrollEnd () {
        // console.log('CurrentPage => ', this.slide.getCurrentPage())
      },
      nextPage() {
        this.slide.next()
      },
      prePage() {
        this.slide.prev()
      }
    }
  }
</script>

<style lang="scss">
    .page-wrap{
        height: 92vh;
        display: flex;
        flex-direction: column;
    }
    .header-area{
        flex-shrink: 0;
    }


    .slide-specified-index {
        flex-grow: 1;
        height: 1px;
        .banner-wrapper {
            position: relative;
            height: 100%;
            display: flex;
        }
        .slide-specified-wrapper {
            min-height: 1px;
            overflow: hidden;
        }
        .slide-specified-content {
            display: flex;
            height: 100%;
        }
        .slide-page {
            display: flex;
            width: 100%;
            height: 100%;
            flex-direction: column;
            background-size:100% 100%;
        }
        .slide-page.page1 {
            background-color: #ea7272;
        }
        .slide-page.page2 {
            background-color: #dda789;
        }
        .slide-page.page3 {
            background-color: #c3d899;
        }
        .slide-page.page4 {
            background-color: #f2d4a7;
        }
        .page-tit{
            padding: 20px;
            display: flex;
            align-items: flex-end;
            strong{
                font-size: 5vw;
                position: relative;
                color: #fff;
                &:after{
                    content: '';
                    position: absolute;
                    height: 0.5vw;
                    border-radius: 1vw;
                    background-color: #d7000f;
                    left: 0;
                    top: 100%;
                    margin-top: 2vw;
                    width: 120%;
                }
            }
            span{
                font-weight: 300;
                color:#fff;
                margin-left: 3vw;
                font-size: 4vw;
            }
        }
        .dots-wrapper {
            bottom: 20px;
            left: 50%;
            position: absolute;
            transform: translateX(-50%);
            .dot {
                border-color: #fff;
                border-style: solid;
                border-width: 2px;
                border-radius: 50%;
                display: inline-block;
                height: 8px;
                margin: 0 4px;
                width: 8px;
            }
            .dot.active {
                background-color: #fff;
            }
        }
        .page-con{
            flex-grow: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            .tit{
                font-size: 5vw;
                color:#fff;
            }
            p{
                margin: 18vw 5vw 20vw;
                color:#fff;
                font-size: 3.4vw;
                line-height: 4.5vw;
            }
            .btn6{
                width: 30vw;
                height: 4vh;
                background-color:#d7000f;
                color:#fff;
                display: flex;
                opacity: 0;
                border-radius:1vw;
                justify-content: center;
                align-items: center;
                font-size: 3.5vw;
            }
        }

    }
</style>